import { type AppErrorOptions, ConflictError } from "../error/errors.ts";

export const DUPLICATE_SUPPLIER_CONTACT_EMAIL_ERROR_CODE = "DUPLICATE_SUPPLIER_CONTACT_EMAIL";

export class DuplicateSupplierContactEmailError extends ConflictError {
  constructor(options?: AppErrorOptions) {
    super("A contact with this email already exists for this supplier", {
      ...options,
      code: DUPLICATE_SUPPLIER_CONTACT_EMAIL_ERROR_CODE,
      logLevel: "warn",
    });
    this.name = "DuplicateSupplierContactEmailError";
  }
}
